import { useState, useCallback } from 'react';
import VoucherDistributionService from '../services/VoucherDistributionService/VoucherDistributionService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useVoucherDistribution = () => {
    const [loading, setLoading] = useState(false);

    // --- FUNZIONE MANCANTE AGGIUNTA ---
    const getMagazzino = useCallback(async (data) => {
        setLoading(true);
        try {
            const response = await VoucherDistributionService.getMagazzino(data);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);
    
    const distributeVoucher = useCallback(async (data) => {
        setLoading(true);
        try {
            await VoucherDistributionService.distribute(data);
            alertService.success("Voucher distribuiti con successo!", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    const getHistoryForAgenzia = useCallback(async (id_agenzia) => {
        setLoading(true);
        try {
            const response = await VoucherDistributionService.getHistoryForAgenzia(id_agenzia);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        isLoading: loading,
        getMagazzino, // Esportiamo la nuova funzione
        distributeVoucher, 
        getHistoryForAgenzia
    };
};

export default useVoucherDistribution;